export const retornaBuscaBusster = (busca, busster) => {
  const regex = new RegExp(`${busca}#=([\\d]+)`);
  const match = busster.match(regex);

  if (match && match[1]) {
    return match[1];
  } else {
    return null;
  }
};
